import React, { RefObject } from 'react';
import classNames from 'classnames/bind';

import { useCommunityContext } from 'components/CommunityContext';
import AddCommentContainer from 'components/AddCommentContainer';
import AddCommentModal from 'components/AddCommentModal';
import FollowPostButton from 'components/FollowPostButton';

import Button from 'koba/components/Button';
import Surface from 'koba/components/Surface';
import { AttachmentInput } from 'types/attachment';
import { TFunction } from 'next-i18next';
import styles from './TopBarMobilePostPage.module.scss';

const cx = classNames.bind(styles);

type Post = {
  id: string;
  isFollowing: boolean;
  pinnedAt: string;
  postAttachments: Array<AttachmentInput>;
};

interface TopBarMobilePostPageProps {
  additionalClassName?: string;
  communityWrapperRef: RefObject<HTMLElement | null>;
  lastCommentRef: RefObject<HTMLElement | null>;
  post?: Post | null;
  t: TFunction;
  onPostChange(): void;
}

const TopBarMobilePostPage: React.FC<TopBarMobilePostPageProps> = ({
  additionalClassName,
  post,
  t,
  lastCommentRef,
  communityWrapperRef,
  onPostChange,
}) => {
  const { community } = useCommunityContext();
  const color = community.primaryColor;

  const renderButton = (openCommentModal) => (
    <Button
      appearance="default"
      color={color}
      size="small"
      onClick={openCommentModal}
    >
      {t('Comment')}
    </Button>
  );

  const renderInput = (inputProps) => (
    <AddCommentModal
      additionalClassName={additionalClassName}
      {...inputProps}
      renderButton={renderButton}
    />
  );

  return (
    <>
      <Surface className={cx('comment-top-bar-mobile')}>
        <div className={cx('comment-top-bar-mobile__actions')}>
          <FollowPostButton
            post={post}
            t={t}
            isMobile
            onPostChange={onPostChange}
          />
          <AddCommentContainer
            communityWrapperRef={communityWrapperRef}
            lastCommentRef={lastCommentRef}
            parentPostId={post?.id || ''}
            renderChildren={renderInput}
            t={t}
            onCommentSubmitted={onPostChange}
          />
        </div>
      </Surface>
    </>
  );
};

export default TopBarMobilePostPage;
